import React, { Component }  from 'react';
import {Space, Card, message, Button, Tag, PageHeader, Spin} from 'antd';
import '../../style.css';
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';

class RegisterCertificatePapers extends Component {
	constructor(props) {
		super(props);
		this.state={
			fileField:[],
			companyId:this.props.companyId,
			companyName:this.props.companyName,
			flag:true,
			checkStatus:false,
			loadingPreview:false,
			fileStream:'',
			loading:false,
			loadingFirst:false,
		}
		this.fileInput = this.fileInput.bind(this);
		this.upload = this.upload.bind(this);
	}
	componentDidMount() {
		this.setState(()=>({
			loadingFirst:true,
		}))
		let params = {
			companyId:this.state.companyId,
			projectId:0,
			productId:0,
			patentId:0,
			otherId:0,
			remark:'企业注册登记证件',
			url:'',
		}
		fetchPost(global.constants.checkFile,params)
			.then(
				res=> {
					if (res.code === 200) {
						this.setState(() => ({
							checkStatus: true,
						}))
						let params = {
							companyId:this.state.companyId,
							projectId:0,
							productId:0,
							patentId:0,
							otherId:0,
							remark: '企业注册登记证件',
							url: '',
							fileName: ''
						}
						fetchPostFile(global.constants.previewFile, params)
							.then(
								res => {
									res.blob().then(
										blob => {
											let blobUrl = window.URL.createObjectURL(blob);
											this.setState(() => ({
												fileStream: blobUrl,
												loadingFirst:false,
												loadingPreview:true,
											}))
										})
								}
							)
					} else {
						this.setState(()=>({
							fileStream:'',
							checkStatus:false,
							loadingPreview:false,
							loadingFirst:false,
						}))
					}
				})
	}

	fileInput(){
		this.setState(()=>({
			checkStatus:false,
			fileField:document.querySelector("input[type='file'][name='file']"),
			flag:false
		}))
	}
	upload() {
		this.setState(()=>({
			loading:true
		}))
		const formdata = new FormData();
		formdata.append('file', this.state.fileField.files[0]);
		formdata.append('companyId', this.state.companyId);
		formdata.append('projectId', 0);
		formdata.append('productId', 0);
		formdata.append('patentId',0);
		formdata.append('otherId',0);
		formdata.append('remark', '企业注册登记证件');
		if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
			alert("只允许上传pdf格式的文件")
			this.setState(()=>({
				loading:false
			}))
		}else{
			fetch(global.constants.uploadFile, {
				method: 'POST',
				body: formdata,
				mode: 'cors',
				credentials: 'include',
			})
				.then(res => res.json())
				.then(
					res => {
						if(res.code === 200){
							let params = {
								companyId:this.state.companyId,
								projectId:0,
								productId:0,
								patentId:0,
								otherId:0,
								remark:'企业注册登记证件',
								url: '',
								fileName: ''
							}
							fetchPostFile(global.constants.previewFile,params)
								.then(
									res=>{
										res.blob().then(
											blob=> {
												let blobUrl = window.URL.createObjectURL(blob);
												this.setState(()=>({
													fileStream:blobUrl,
													checkStatus:true,
													loadingPreview:true,
													loading:false
												}))
											})
									}
								)
							message.success("上传成功，加载预览中...").then()
						}
						else{
							message.info(res.msg).then()
						}
					})
		}
	}
	delete(){
		let params = {
			companyId:this.state.companyId,
			projectId:0,
			productId:0,
			patentId:0,
			otherId:0,
			remark:'企业注册登记证件',
			url: '',
		}
		fetchPost(global.constants.deleteFile,params)
			.then(
				res=>{
					if(res.code === 200){
						message.success("删除成功").then()
						this.setState(()=>({
							checkStatus:false,
							loadingPreview:false,
						}))
					}
				}
			)
	}
    render() {
        return(
			<div>
				<div className="content-page-header">
					<PageHeader
						ghost={false}
						title="企业注册登记证件"
						subTitle='只允许上传50M以内的pdf格式的文件'
						tags={
							this.state.checkStatus === true?<Tag color="green" className="Tag_style">
								已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>

						}
						extra={[
							<input type="file" name='file' onChange={this.fileInput}/>,
							<Button type="primary" onClick={this.upload} disabled={this.state.flag}>上传</Button>,
							<Spin tip={"上传中..."} spinning={this.state.loading}/>,
							<Button onClick={this.delete.bind(this)} disabled={!this.state.checkStatus}>删除</Button>,
						]}
					>
					</PageHeader>
					</div>
					<Space direction="vertical" className="content-style" >
						<Card bordered={true} style={{border:'solid  1px #7F9DB9',textAlign:'center'}} >
							<div style = {{fontSize:30, paddingBottom:20}} >
								<Spin tip={"加载预览中..."} spinning={this.state.loadingFirst}/>
								{
									(this.state.checkStatus === true && this.state.loadingPreview === true) &&
									<FileViewer fileType='pdf'
										filePath={this.state.fileStream}
										onError={this.onError}
									/>
								}
							</div>
						</Card>
					</Space>
			</div>
        )
    }
}
export default RegisterCertificatePapers;